/**
 * Typed Redux Hooks
 * Provides type-safe hooks for use in components
 */

import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed useDispatch hook
 * @returns {AppDispatch} Typed dispatch function
 */
export const useAppDispatch = () => useDispatch();

/**
 * Typed useSelector hook
 * @template T
 * @param {(state: RootState) => T} selector - Selector function
 * @returns {T} Selected state
 */
export const useAppSelector = useSelector;
